import apiClient from '../api/apiClient';

const BASKET_ORDERS_BASE = '/api/v1/admin/basket-orders';
const BASKETS_BASE = '/api/v1/admin/baskets';

const stripEmpty = (obj) =>
  Object.fromEntries(
    Object.entries(obj).filter(([, v]) => v !== '' && v !== null && v !== undefined)
  );

const unwrap = (response) => {
  const body = response?.data;
  if (body && typeof body === 'object' && 'data' in body) return body.data;
  return body;
};

const basketOrderService = {
  adminListBasketOrders: async (params = {}) => {
    const defaults = {
      page: 1,
      limit: 10,
      sort_by: 'created_at',
      sort_order: 'desc',
    };
    const response = await apiClient.get(BASKET_ORDERS_BASE, {
      params: stripEmpty({ ...defaults, ...params }),
    });
    return unwrap(response);
  },

  adminGetBasketOrder: async (uuid) => {
    const response = await apiClient.get(`${BASKET_ORDERS_BASE}/${uuid}`);
    const data = unwrap(response);
    return data?.basket_order ?? data;
  },

  confirmPayment: async (uuid, { utr_number }) => {
    const response = await apiClient.patch(`${BASKET_ORDERS_BASE}/${uuid}/confirm-payment`, {
      utr_number,
    });
    return unwrap(response);
  },

  updateUtr: async (uuid, utr_number) => {
    const response = await apiClient.patch(`${BASKET_ORDERS_BASE}/${uuid}/utr`, {
      utr_number,
    });
    return unwrap(response);
  },

  sendPaymentLink: async (uuid, payload = {}) => {
    const response = await apiClient.post(`${BASKET_ORDERS_BASE}/${uuid}/send-payment-link`, payload);
    return unwrap(response);
  },

  syncStatus: async (uuid) => {
    const response = await apiClient.post(`${BASKET_ORDERS_BASE}/${uuid}/sync-status`);
    return unwrap(response);
  },

  transferShares: async (uuid, payload = {}) => {
    const response = await apiClient.post(
      `${BASKET_ORDERS_BASE}/${uuid}/transfer-shares`,
      stripEmpty(payload)
    );
    return unwrap(response);
  },

  adminCalculatePrice: async (basketUuid, params) => {
    const response = await apiClient.get(`${BASKETS_BASE}/${basketUuid}/calculate-price`, {
      params: stripEmpty(params),
    });
    return unwrap(response);
  },

  adminPlaceBasketOrder: async (payload) => {
    const response = await apiClient.post(BASKET_ORDERS_BASE, payload);
    return unwrap(response);
  },
};

export default basketOrderService;
